import { render, staticRenderFns } from "./HistoricoFinanceiro.vue?vue&type=template&id=1d583fee&"
import script from "./HistoricoFinanceiro.vue?vue&type=script&lang=js&"
export * from "./HistoricoFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports